var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { styled } from 'styled-components';
import { Down, Left, Right, Up } from '@hn-ui/icons';
import { useGroupSkills } from '../../hooks/useGroupSkills';
import { Table } from '../../../Common/components/Table';
import { StudentSkillCell } from './StudentSkillCell';
import { StudentNameCell, NameHeaderCell } from './StudentNameCell';
import { createSkillColumnId, getAdditionalRowProps, renderRowTooltip, checkIfStudentRow, checkIfCurrentGradesRangeStarted, calculateLevelLabelWidth, getFilterColumns, } from './tableConfig';
import { GradeHeaderCell } from './GradeHeaderCell';
import { CHEVRON_COLUMN_WIDTH, COLUMN_WIDTH, LAST_COLUMN_WIDTH, VISIBLE_COLUMNS_COUNT, FILTER_COLUMN_ID, } from '../../constants/table';
import SkillsTablePreloader from './Preloader';
import { ExpandRowButton } from './ExpandRowButton';
import { ReportLinkCell } from './ReportLinkCell';
import { useStudentsSkillsTableData } from './hooks/useStudentsSkillsTableData';
import { useTableGradesPagination } from './hooks/useTableGradesPagination';
import { useTableRowActions } from './hooks/useTableRowActions';
import { useStudentsSkillsTableAnalytics } from './hooks/useStudentsSkillsTableAnalytics';
import { zIndexes } from '../../constants/DOM';
import { SkillLevelCell } from './SkillLevelCell';
import defaultTheme from '../../../../../landing/components/core/themes/theme';
import { SkillHeaderCell } from './SkillHeaderCell';
import { SkillStatus } from '../../constants/statuses';
var ScButton = styled.button.withConfig({ displayName: "ScButton", componentId: "sc-cud8q3" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  color: ", ";\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  width: 48px;\n  height: 154px;\n  background-color: ", ";\n  border-radius: ", ";\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n"], ["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-weight: 700;\n  color: ", ";\n  font-size: 10px;\n  line-height: 16px;\n  letter-spacing: 0.6px;\n  text-transform: uppercase;\n  background: transparent;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  width: 48px;\n  height: 154px;\n  background-color: ", ";\n  border-radius: ", ";\n\n  &:hover {\n    color: ", ";\n\n    svg {\n      fill: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue95;
}, function (_a) {
    var dir = _a.dir;
    return dir === 'left' ? '8px 0 0 8px' : '0 8px 8px 0';
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
});
var ScWrapper = styled.div.withConfig({ displayName: "ScWrapper", componentId: "sc-1wny5s6" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: contents;\n\n  @media (hover: hover) and (pointer: fine) {\n    tbody tr[role='row'][data-hoverable='true'] {\n      &:hover {\n        cursor: pointer;\n        background-color: ", ";\n      }\n    }\n  }\n\n  thead {\n    z-index: ", " !important;\n\n    tr:last-child th {\n      height: 130px;\n      padding-bottom: 8px;\n\n      > *:not(", ") {\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n\n  tbody {\n    tr:first-child td {\n      padding-top: 32px;\n    }\n  }\n"], ["\n  display: contents;\n\n  @media (hover: hover) and (pointer: fine) {\n    tbody tr[role='row'][data-hoverable='true'] {\n      &:hover {\n        cursor: pointer;\n        background-color: ", ";\n      }\n    }\n  }\n\n  thead {\n    z-index: ", " !important;\n\n    tr:last-child th {\n      height: 130px;\n      padding-bottom: 8px;\n\n      > *:not(", ") {\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n      }\n    }\n  }\n\n  tbody {\n    tr:first-child td {\n      padding-top: 32px;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue99;
}, zIndexes.tableHead, ScButton);
var ScChevronCell = styled.div.withConfig({ displayName: "ScChevronCell", componentId: "sc-18m3v5o" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  margin-left: auto;\n\n  svg {\n    fill: ", ";\n  }\n\n  button[data-disabled='true'] + svg {\n    fill: ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  margin-left: auto;\n\n  svg {\n    fill: ", ";\n  }\n\n  button[data-disabled='true'] + svg {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue50;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.black80;
});
var STUDENTS_NAME_COLUMN_ID = 'StudentsMainColumn';
var StudentsSkillsTable = function (_a) {
    var groupId = _a.groupId, schoolId = _a.schoolId, domain = _a.domain, onLoad = _a.onLoad, filters = _a.filters, groupGradeValue = _a.groupGradeValue, selectedData = _a.selectedData, setSelectedData = _a.setSelectedData, props = __rest(_a, ["groupId", "schoolId", "domain", "onLoad", "filters", "groupGradeValue", "selectedData", "setSelectedData"]);
    var _b = useGroupSkills({
        groupId: groupId,
        domainId: domain.id,
        schoolId: schoolId,
    }), groupSkills = _b.data, isLoading = _b.isLoading;
    var _c = useStudentsSkillsTableData({
        groupSkills: groupSkills,
        groupGradeValue: groupGradeValue,
    }), tableData = _c.tableData, groupedStudents = _c.groupedStudents, students = _c.students, grades = _c.grades, handleSortChange = _c.handleSortChange;
    var _d = useTableGradesPagination({
        groupGradeValue: groupGradeValue,
        grades: grades,
        students: students,
        selectedGradeShortName: selectedData === null || selectedData === void 0 ? void 0 : selectedData.gradeShortName,
        filters: filters,
    }), renderedGrades = _d.renderedGrades, prevGrade = _d.prevGrade, nextGrade = _d.nextGrade, goPrev = _d.goPrev, goNext = _d.goNext;
    var _e = useTableRowActions({
        domain: domain,
        groupSkills: groupSkills,
        selectedData: selectedData,
        setSelectedData: setSelectedData,
    }), updateRow = _e.updateRow, renderSubRow = _e.renderSubRow;
    var _f = useStudentsSkillsTableAnalytics(), handleStudentNameClick = _f.handleStudentNameClick, handleStudentRowClick = _f.handleStudentRowClick, handleStudentSkillCellClick = _f.handleStudentSkillCellClick, handleStudentReportLinkClick = _f.handleStudentReportLinkClick, handleExpandRowButtonClick = _f.handleExpandRowButtonClick, handleChangePageClick = _f.handleChangePageClick;
    var filterColumns = React.useMemo(function () { return getFilterColumns(students); }, [students]);
    var columns = React.useMemo(function () {
        var columnsCount = 0;
        var prevGradeLevel;
        var firstGradeInLevel = false;
        var gradeColumns = renderedGrades.map(function (grade) {
            if (grade.level !== prevGradeLevel) {
                prevGradeLevel = grade.level;
                firstGradeInLevel = true;
            }
            else {
                firstGradeInLevel = false;
            }
            return {
                id: String(grade.id),
                Header: function (headerCellProps) { return (_jsx(GradeHeaderCell, __assign({}, headerCellProps, { children: grade.shortName + " skills" }), void 0)); },
                columns: grade.skills.map(function (skill, skillIdx) {
                    columnsCount += 1;
                    var columnId = createSkillColumnId(skill);
                    var firstSkillInLevel = firstGradeInLevel && skillIdx === 0;
                    return {
                        id: columnId,
                        canSort: true,
                        sortDescFirst: true,
                        Header: function () { return _jsx(SkillHeaderCell, { skillName: skill.name }, void 0); },
                        Cell: function (_a) {
                            var row = _a.row, cellProps = __rest(_a, ["row"]);
                            return checkIfStudentRow(row.original) ? (_jsx(StudentSkillCell, __assign({}, cellProps, { row: row, skillId: skill.id, onSkillClick: handleStudentSkillCellClick }), void 0)) : (_jsx(SkillLevelCell, { renderLabel: firstSkillInLevel, level: grade.level, singleInGrade: grade.skills.length === 1, started: checkIfCurrentGradesRangeStarted({
                                    level: grade.level,
                                    minGradeValue: renderedGrades[0].value,
                                    maxGradeValue: renderedGrades[renderedGrades.length - 1].value,
                                    students: groupedStudents[row.original.level],
                                }), maxWidth: firstSkillInLevel
                                    ? calculateLevelLabelWidth(renderedGrades, grade.level, groupGradeValue)
                                    : undefined }, void 0));
                        },
                        style: {
                            minWidth: COLUMN_WIDTH,
                            maxWidth: COLUMN_WIDTH,
                            borderLeft: skillIdx === 0
                                ? "2px solid " + defaultTheme.colors.black95
                                : undefined,
                        },
                    };
                }),
            };
        });
        var tColumns = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], filterColumns, true), [
            {
                id: STUDENTS_NAME_COLUMN_ID,
                Header: function (cellProps) { return (_jsx(NameHeaderCell, __assign({}, cellProps, { children: prevGrade && (_jsxs(ScButton, __assign({ type: 'button', onClick: function () {
                            goPrev();
                            handleChangePageClick();
                        }, dir: 'left' }, { children: [_jsxs("div", { children: [prevGrade.shortName, _jsx("br", {}, void 0), "skills"] }, void 0), _jsx(Left, {}, void 0)] }), void 0)) }), void 0)); },
                disableSortBy: true,
                accessor: 'name',
                Cell: function (cellProps) { return (_jsx(StudentNameCell, __assign({}, cellProps, { onNameClick: handleStudentNameClick }), void 0)); },
                style: {
                    minWidth: 200,
                    maxWidth: 200,
                    paddingLeft: 24,
                    paddingRight: 19,
                },
            }
        ], false), gradeColumns, true), [
            {
                id: 'student-report-link',
                Cell: function (_a) {
                    var row = _a.row, cellProps = __rest(_a, ["row"]);
                    return checkIfStudentRow(row.original) ? (_jsx(ReportLinkCell, __assign({}, cellProps, { row: row, onLinkClick: handleStudentReportLinkClick }), void 0)) : (_jsx(SkillLevelCell, {}, void 0));
                },
                style: {
                    minWidth: LAST_COLUMN_WIDTH,
                    maxWidth: LAST_COLUMN_WIDTH,
                },
            },
        ], false);
        var restWidth = COLUMN_WIDTH * (VISIBLE_COLUMNS_COUNT - columnsCount) +
            CHEVRON_COLUMN_WIDTH;
        var prevLastColumn = {
            id: 'expand-button-column',
            Cell: function (_a) {
                var row = _a.row, cellProps = __rest(_a, ["row"]);
                if (!checkIfStudentRow(row.original))
                    return _jsx(SkillLevelCell, {}, void 0);
                var isStruggle = row.original.skills.some(function (skill) { return skill.status === SkillStatus.HelpNeeded; });
                return (_jsxs(ScChevronCell, __assign({ style: { width: CHEVRON_COLUMN_WIDTH } }, { children: [_jsx(ExpandRowButton, __assign({}, cellProps, { row: row, onClick: function () { return handleExpandRowButtonClick(isStruggle); } }), void 0), row.isExpanded ? _jsx(Up, {}, void 0) : _jsx(Down, {}, void 0)] }), void 0));
            },
            style: {
                minWidth: restWidth,
                maxWidth: restWidth,
                verticalAlign: 'middle',
            },
        };
        if (nextGrade) {
            tColumns[tColumns.length - 1].Header = (_jsxs(ScButton, __assign({ type: 'button', onClick: function () {
                    goNext();
                    handleChangePageClick();
                }, dir: 'right' }, { children: [_jsxs("div", { children: [nextGrade.shortName, _jsx("br", {}, void 0), "skills"] }, void 0), _jsx(Right, {}, void 0)] }), void 0));
        }
        var prevLastIndex = tColumns.length - 1;
        tColumns.splice(prevLastIndex, 0, prevLastColumn);
        return tColumns;
    }, [
        renderedGrades,
        filterColumns,
        nextGrade,
        groupGradeValue,
        groupedStudents,
        prevGrade,
        goPrev,
        handleChangePageClick,
        handleExpandRowButtonClick,
        goNext,
    ]);
    var filterColumn = React.useMemo(function () { return ({
        columnId: FILTER_COLUMN_ID,
        value: filters,
    }); }, [filters]);
    var isDataLoaded = !isLoading && groupSkills;
    React.useEffect(function () {
        if (isDataLoaded) {
            onLoad === null || onLoad === void 0 ? void 0 : onLoad(groupSkills);
        }
    }, [groupSkills, isDataLoaded, onLoad]);
    if (!isDataLoaded)
        return _jsx(SkillsTablePreloader, {}, void 0);
    return (_jsx(ScWrapper, { children: _jsx(Table, __assign({ columns: columns, data: tableData, isFlexLayout: false, filterColumn: filterColumn, hiddenColumns: [FILTER_COLUMN_ID], manualSortBy: true, renderSubRow: renderSubRow, onSortChange: handleSortChange, renderRowContent: renderRowTooltip, getAdditionalRowProps: getAdditionalRowProps, updateRow: updateRow, stickyHeader: true, stickyHeaderTopOffset: 56, testId: 'students-skills-table' }, props), void 0) }, void 0));
};
export { StudentsSkillsTable };
var templateObject_1, templateObject_2, templateObject_3;
